function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import MaterialDialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/styles";
import { useTrackerContext } from "@dpdgroupuk/react-event-tracker";
import { TrackableDialog } from "./Provider";
import Button from "../Button";
const useStyles = makeStyles(({
  palette,
  typography
}) => ({
  title: {
    height: typography.pxToRem(44)
  },
  text: {
    textAlign: "center",
    fontSize: typography.pxToRem(18),
    letterSpacing: 0.2,
    color: palette.text.primary
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 0,
    color: "rgba(128, 130, 133, 0.56)"
  },
  footer: {
    justifyContent: "center",
    paddingBottom: typography.pxToRem(25),
    paddingTop: typography.pxToRem(13)
  },
  button: {
    padding: `${typography.pxToRem(11)} ${typography.pxToRem(22)}`
  },
  buttonLabel: {
    fontSize: typography.pxToRem(13),
    lineHeight: 1.2
  },
  backgroundModal: {
    backgroundColor: palette.background.modal,
    borderRadius: typography.pxToRem(6)
  }
}));

const Error = ({
  title = "Error.",
  description = "Please check your details and try again.",
  buttonText = "Try again",
  onConfirm,
  onClose,
  analytics,
  ...props
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(MaterialDialog, _extends({
    maxWidth: "xs",
    fullWidth: true,
    classes: {
      paper: styles.backgroundModal
    },
    onClose: onClose
    /* $FlowFixMe This comment suppresses an error found when upgrading Flow
     * to v0.112.0. To view the error, delete this comment and run Flow. */

  }, props), /*#__PURE__*/React.createElement(TrackableDialog, {
    analytics: analytics
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: styles.title
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    className: styles.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
    className: styles.text
  }, title), /*#__PURE__*/React.createElement(DialogContentText, {
    className: styles.text
  }, description)), /*#__PURE__*/React.createElement(DialogActions, {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    classes: {
      root: styles.button,
      label: styles.buttonLabel
    },
    autoFocus: true
  }, buttonText))));
};

const TrackableError = props => {
  const {
    analytics,
    onConfirm
  } = props;
  const tracker = useTrackerContext();
  const onTrackableConfirm = React.useCallback(() => {
    analytics && tracker.logEvent(analytics.confirm);
    onConfirm();
  }, [onConfirm, analytics, tracker]);
  return /*#__PURE__*/React.createElement(Error, _extends({}, props, {
    onConfirm: analytics ? onTrackableConfirm : onConfirm
  }));
};

export default TrackableError;